import { Directive, HostListener } from '@angular/core';

@Directive({
    selector: '[multiTabContextMenuItemRef]',
    standalone: false
})
export class MultiTabContextMenuItemRefDirective {
    clicked = false;

    @HostListener('click')
    contextItemClicked() {
        this.clicked = true;
    }
}
